import { render, staticRenderFns } from "./clients.vue?vue&type=template&id=40ca573f&scoped=true&"
import script from "./clients.vue?vue&type=script&lang=ts&"
export * from "./clients.vue?vue&type=script&lang=ts&"
import style0 from "./clients.vue?vue&type=style&index=0&id=40ca573f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ca573f",
  null
  
)

component.options.__file = "clients.vue"
export default component.exports